import React from 'react';
import SbEditable from 'storyblok-react';
import ReactMarkdown from 'react-markdown';

import './header-text.scss';

const HeaderText = (props) => {
  const classes = ['header-text'];
  classes.push('theme-' + props.blok.theme);
  classes.push('textalign-' + props.blok.text_alignment);

  return (
    <SbEditable content={props.blok}>
      <div className={classes.join(' ')}>
        <h1>{props.blok.header}</h1>
        <ReactMarkdown children={props.blok.body} />
      </div>
    </SbEditable>
  );
};

export default HeaderText;
